import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContactAndAddressService } from '@services/contact-and-address/contact-and-address.service';
import { TranslateService } from '@services/translate/translate.service';
import { Models } from '@ibexfusion/models';
import { MessengerService } from '@services/messenger/messenger.service';
import { TimePickerComponent } from '../../../../../../components/time-picker/time-picker.component';

@Component({
    selector: 'edit-event-dates-dialog',
    templateUrl: './edit-event-dates-dialog.component.html',
    styleUrls: ['./edit-event-dates-dialog.component.scss'],
    providers: [],
    standalone: false
})
export class EditEventDatesDialogComponent implements OnInit {

  translation: any;
  element: any;

  constructor(
    public dialogRef: MatDialogRef<EditEventDatesDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private ts: TranslateService, private dialog: MatDialog
  ) {
    this.ts.get('dynamnicContent');
  }

  async ngOnInit() {
    this.element = this.data.element || { startDate: null, endDate: null, startTime: null, endTime: null, daily: false };
  }

  async openTimePicker(type: string) {
    let dialogRef: MatDialogRef<TimePickerComponent>;
    dialogRef = this.dialog.open(TimePickerComponent, { width: '398px', height: '548px', panelClass: 'time', data: this.element[type] });
    const result = await dialogRef.afterClosed().toPromise();
    if (result) {
      this.element[type] = this.convertResultToString(result);
    }
  }

  convertResultToString(result: any): string {
    return `${String(result.hour).padStart(2, '0')}:${String(result.minute).padStart(2, '0')}`;
  }

  async save() {
    this.dialogRef.close(this.element);
  }
}
